import React from 'react'
import { useTheme } from 'styled-components'
import Heading from '../../components/Heading/Heading'
import getThemeValue from '../../util/getThemeValue'
import { ModalBody, ModalHeader, ModalTitle, ModalContainer, ModalCloseButton, ModalBackButton } from './styles'
import { ModalProps } from './types'

const Modal: React.FC<ModalProps> = ({
  title,
  onDismiss,
  onBack,
  children,
  hideHeader = false,
  hideCloseButton = false,
  bodyPadding = '24px',
  headerBackground = 'transparent',
  minWidth = '320px',
  maxWidth = '100%',
  border = 'cardBorder',
  borderRadius = '32px',
  headerTextColor = 'white',
  withHeaderBottomBorder = true,
  background,
  ...props
}) => {
  const theme = useTheme()
  return (
    <ModalContainer
      minWidth={minWidth}
      maxWidth={maxWidth}
      {...props}
      border={border}
      borderRadius={borderRadius}
      background={background || theme.modal.background}
    >
      {!hideHeader && (
        <ModalHeader
          background={getThemeValue(`colors.${headerBackground}`, headerBackground)(theme)}
          withBorderBottom={withHeaderBottomBorder}
        >
          <ModalTitle>
            {onBack && <ModalBackButton color={headerTextColor} onBack={onBack} />}
            <Heading color={headerTextColor}>{title}</Heading>
          </ModalTitle>
          {!hideCloseButton && <ModalCloseButton color={headerTextColor} onDismiss={onDismiss} />}
        </ModalHeader>
      )}
      <ModalBody p={bodyPadding}>{children}</ModalBody>
    </ModalContainer>
  )
}

export default Modal
